import colors from './colors.js'
import breakpoints from './breakpoints.js'
import spacing from './spacing.js'
import transitions from './transitions.js'
import typography from './typography.js'
import borders from './borders.js'
import shadows from './shadows.js'

export default {
  ...spacing,
  ...breakpoints,
  ...colors,
  ...transitions,
  ...typography,
  ...borders,
  ...shadows,
}
